<template>
  <section class="ep-list">
    <div
      v-for="(ep, index) in emissionPoints"
      :key="index"
      :class="['stab-card', { 'is-default': ep.is_default }]"
    >
      <div class="stab-card-icon">
        <i class="el-icon-printer"></i>
      </div>
      <div class="stab-card-info">
        <div class="stab-card-name">Punto {{ ep.code }}</div>
        <div class="stab-card-code">
          {{ ep.description || "Sin descripción" }}
        </div>
      </div>
      <div class="stab-card-actions">
        <el-tooltip
          :content="
            ep.is_default
              ? 'Punto por defecto'
              : 'Establecer como predeterminado'
          "
          placement="top"
        >
          <button
            :class="['stab-action-btn', { 'is-active': ep.is_default }]"
            @click.stop="setEmissionPointDefault(index)"
          >
            <i class="el-icon-check"></i>
          </button>
        </el-tooltip>
        <el-tooltip content="Editar" placement="top">
          <button
            class="stab-action-btn"
            @click.stop="onClickEditEmissionPoint(ep, index)"
          >
            <i class="el-icon-edit"></i>
          </button>
        </el-tooltip>
        <ButtonDeleteComponent
          :isShowButton="false"
          @onConfirmDelete="onConfirmDeleteEmissionPoint(ep, index)"
        />
      </div>
    </div>

    <div v-if="!emissionPoints.length" class="stab-empty">
      <i class="el-icon-printer"></i>
      <span>No hay puntos de emisión</span>
    </div>

    <el-button size="small" class="ep-add-btn" @click="onClickAddEmissionPoint">
      <i class="el-icon-plus"></i> Nuevo punto de emisión
    </el-button>

    <BusinessEmissionPointAddComponent
      @onCloseDrawer="onCloseEmissionPointAddDrawer"
      :visible.sync="visibleAddEmissionPoint"
      :establishmentId="establishmentId"
      @onEmissionPointAdded="onEmissionPointAdded"
    />

    <BusinessEmissionPointEditComponent
      @onCloseDrawer="onCloseEmissionPointEditDrawer"
      :visible.sync="visibleEditEmissionPoint"
      @onEmissionPointEdited="onEmissionPointEdited"
    />
  </section>
</template>

<script>
import BusinessEmissionPointAddComponent from "./EmissionPointAdd";
import BusinessEmissionPointEditComponent from "./EmissionPointEdit";
import ButtonDeleteComponent from "../../../../components/ButtonDelete";
import tradeService from "../../../services/tradeService";

export default {
  name: "BusinessEmissionPointListComponent",
  data() {
    return {
      visibleAddEmissionPoint: false,
      visibleEditEmissionPoint: false,
      emissionPoints: this.setEmissionPoints || [],
      emissionPointIndexActived: null
    };
  },
  methods: {
    onClickAddEmissionPoint() {
      this.visibleAddEmissionPoint = true;
    },
    onCloseEmissionPointAddDrawer() {
      this.visibleAddEmissionPoint = false;
    },
    onClickEditEmissionPoint(emissionPoint, emissionPointIndex) {
      this.emissionPointIndexActived = emissionPointIndex;
      this.$root.$emit("onEmissionPointEdit", emissionPoint);
      this.visibleEditEmissionPoint = true;
    },
    onCloseEmissionPointEditDrawer() {
      this.visibleEditEmissionPoint = false;
    },
    onEmissionPointAdded({ getEmissionPoint }) {
      this.emissionPoints.push(getEmissionPoint);
      // Auto-select if it's the only one
      if (this.emissionPoints.length === 1) {
        this.setEmissionPointDefault(0);
      }
    },
    onEmissionPointEdited({ getEmissionPoint }) {
      this.emissionPoints[this.emissionPointIndexActived] = getEmissionPoint;
    },
    async onConfirmDeleteEmissionPoint(emissionPoint, index) {
      this.$store.dispatch("toggleRequestLoading");
      try {
        let response = await tradeService
          .deleteEmissionPointId(emissionPoint)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        const { success, message } = response.data;
        if (success) {
          this.emissionPoints.splice(index, 1);
          this.$notifications.success({ message });
        }
      } catch (error) {
        return false;
      }
    },
    async setEmissionPointDefault(index) {
      try {
        let response = await tradeService.setEmissionPointDefault(
          this.emissionPoints[index]
        );
        if (response.data) {
          this.emissionPoints.forEach((ep, i) => {
            ep.is_default = i === index;
          });
          this.$message.success("Punto de emisión predeterminado actualizado");
        }
      } catch (error) {
        return false;
      }
    }
  },
  components: {
    BusinessEmissionPointAddComponent,
    BusinessEmissionPointEditComponent,
    ButtonDeleteComponent
  },
  props: {
    setEmissionPoints: {
      type: Array
    },
    establishmentId: {
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
$primary: #31355c;
$accent: #3fdbbf;
$border: #e4eaf6;
$bg: #f7f8f9;

.ep-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.stab-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  background: #fff;
  border: 1px solid $border;
  border-radius: 10px;
  margin-bottom: 10px;
  transition: all 0.15s;

  &:hover {
    border-color: darken($border, 10%);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }

  &.is-default {
    border-left: 3px solid $accent;
  }
}
.stab-card-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: $bg;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i {
    font-size: 18px;
    color: $primary;
  }
}
.stab-card-info {
  flex: 1;
  min-width: 0;
}
.stab-card-name {
  font-size: 15px;
  font-weight: 600;
  color: $primary;
}
.stab-card-code {
  font-size: 13px;
  color: #909399;
  margin-top: 2px;
}
.stab-card-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}
.stab-action-btn {
  width: 34px;
  height: 34px;
  border: 1px solid $border;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #909399;
  transition: all 0.15s;

  &:hover {
    background: $bg;
    color: $primary;
    border-color: $primary;
  }

  &.is-active {
    background: #e4fff4;
    border-color: $accent;
    color: #1d9e75;
  }
}

.stab-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 0;
  color: #c0c4cc;
  gap: 8px;

  i {
    font-size: 28px;
  }
  span {
    font-size: 13px;
  }
}

.ep-add-btn {
  margin-top: 12px;
  background: transparent !important;
  border: 1px dashed #c0c4cc !important;
  color: #909399 !important;
  border-radius: 8px;
  width: 100%;
  font-size: 13px;

  &:hover {
    border-color: $accent !important;
    color: $accent !important;
  }
}
</style>
